import * as React from 'react';
import { Avatar as RNPAvatar } from 'react-native-paper';

import Image from '@components/Image';
import { parseUserAcronym } from '@helpers/Parsers';

export type AvatarImageProps = React.ComponentProps<typeof Image> & {
  size: number;
};

const defaultSize = 64;

export function AvatarImage({ size = defaultSize, source, style, ...props }: AvatarImageProps) {
  const geometryStyle = { width: size, height: size, borderRadius: size / 2 };
  return <Image source={source} style={[geometryStyle, style]} {...props} />;
}

export type AvatarIconProps = React.ComponentProps<typeof RNPAvatar.Icon>;

export function AvatarIcon(props: AvatarIconProps) {
  return <RNPAvatar.Icon {...props} />;
}

export type AvatarTextProps = React.ComponentProps<typeof RNPAvatar.Text>;

export function AvatarText(props: AvatarTextProps) {
  return <RNPAvatar.Text {...props} />;
}

export type UserAvatarProps = {
  displayName: string;
  photoUrl: string;
  imageProps?: Omit<AvatarImageProps, 'size' | 'source' | 'style'>;
  size?: number;
  style?: object;
};

export function UserAvatar({
  displayName,
  photoUrl,
  imageProps,
  size = defaultSize,
  style,
}: UserAvatarProps) {
  return photoUrl ? (
    <AvatarImage source={{ uri: photoUrl }} size={size} style={style} {...imageProps} />
  ) : (
    <AvatarText label={parseUserAcronym(displayName)} size={size} style={style} />
  );
}
